import Vue3Toastify, { toast, type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const defaultOptions: ToastContainerOptions = {
  position: 'top-right',
  theme: 'auto',
  autoClose: 2000,
  icon: true,
  limit: 2,
  transition: 'flip',
  clearOnUrlChange: false
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3Toastify, defaultOptions);

  return {
    provide: { toast },
  };
});
